import * as React from 'react';
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';
import { updateImagenesApi, updatePosicionesImagenesApi } from '../../../../api/axios';
import { TrashBinIcon } from '../../../../template/CustomStyle';
import { createImageUrl } from '../../../../api/axios';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ImageModal from '../../../General/ImageModal';
import { toast } from 'react-toastify';
const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}


class DrawAndDropImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      srcImg: "",
      showImg: false,
      imagenes: [],
      changeImages: true,
      sizeImages: this.props?.publicacion?.imagenes?.length,
      reorder: true
    }
  }

  componentDidMount() {
    if (!this.state.imagenes.length) {
      this.setState({ imagenes: this.props.publicacion.imagenes })
    }
  }

  showImgModal = (e, src) => {
    e.preventDefault();
    this.setState({
      showImg: true,
      srcImg: src
    });
  }

  hideImgModal = () => {
    this.setState({ showImg: false });
  }

  addImg = async (e) => {
    let sizeImg = this.checkImageSize();
    if (sizeImg > 500) {
      toast.error("Tamaño de imagen superior a 500kb");
      return;
    } else {
      //Subir imagen
      const image = e.target.files[0];
      let req = createImageUrl(image);
      let posicion = this.state.sizeImages + 1;
      this.setState({ changeImages: false, reorder: false });

      req.then(res => {
        if (res != "") {
          let newImage = { urlImagen: res.url, posicion: posicion };
          this.state.imagenes.push(newImage);
          const imagenes = reorder(this.state.imagenes);
          this.setState({ 
            imagenes: imagenes,
            sizeImages: this.state.imagenes.length
          });
          this.props.publicacion.imagenes = this.state.imagenes;
        } else {
          toast.error(res)
        }
      }).catch(error => console.log())
    }
  }

  deleteImg = (index, imgs,) => {
    imgs.splice(index, 1);
    const imagenes = reorder(imgs);
    this.setState({ 
      imagenes: imagenes,
      changeImages: false,
      sizeImages: this.state.imagenes.length
    });
  }

  onSubmit = (event) => {
    event.preventDefault();
    let updateImagenes = { idPublicacion: this.props.publicacion.idPublicacion, imagenes: this.state.imagenes }
    const req = updateImagenesApi(updateImagenes);
    req.then(res => {
      toast.success("Imagenes editadas");
    }).catch(err => {
      (err.response.data.errores) 
      ? err.response.data.errores.forEach(error => toast.error(error)) 
      : toast.error("No pudo editarse");
    });
  }

  onReorderImagenes = () => {
    if (this.state.reorder) {
      let imagenes = [];
      this.state.imagenes.map(function (img, index) {
        let posicion = index + 1;
        imagenes.push({ idImagen: img.idImagen, posicion: posicion })
      });
      let payload = { idPublicacion: this.props.publicacion.idPublicacion, imagenes: imagenes };
      const req = updatePosicionesImagenesApi(payload);
      req.then(res => {
        toast.success("Imagenes reordenadas, el cambio se verá reflejado a la brevedad");
        this.return();
      }).catch(err => {
        (err.response.data.errores) 
        ? err.response.data.errores.forEach(error => toast.error(error)) 
        : toast.error("No pudo editarse");
      });
    } else {
      toast.error("No se puede reordenar imagenes que no se hayan guardado aún en el sistema. Se recomienda cargarlas en el orden que se quieren mostrar");
      return;
    }
  }

  checkImageSize = () => {
    var fileUpload = document.getElementById("imgInput");
    if (typeof (fileUpload.files) != "undefined") {
      var size = parseFloat(fileUpload.files[0].size / 1024).toFixed(2);
      return size;
    }
  }

  handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index && source.droppableId === destination.droppableId) return;
    if (this.state.reorder) {
      const imagenes = reorder(this.state.imagenes, result.source.index, result.destination.index);
      this.setState({ imagenes });
    }
    this.onReorderImagenes();
  }


  render() {
    return (
      <div name="datos" id="home2" role="tabpanel">
        <DragDropContext onDragEnd={this.handleDragEnd}>
          <Droppable droppableId="imgs" direction="horizontal">
            {(droppableProvided) => (
              <div className="row" {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
                {this.state.imagenes.map((img, index) => (
                  <Draggable key={img?.urlImagen} draggableId={img?.urlImagen} index={index}>
                    {(draggableProvided) => (
                      <div
                        className="col-12 col-sm-4 position-relative"
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.draggableProps}
                        {...draggableProvided.dragHandleProps}
                      >
                        {this.state.sizeImages > 1 &&
                          <div 
                            className="position-absolute top-0 end-0 p-0 z-index-1 allow-pointer-cursor" 
                            onClick={() => { this.deleteImg(index, this.state.imagenes) }}
                          >
                            <TrashBinIcon />
                          </div>
                        }
                        <img
                          src={img?.urlImagen}
                          onClick={e => this.showImgModal(e, img?.urlImagen)}
                          className="on mw-400px img-responsive allow-pointer-cursor"
                        />
                      </div>
                    )}
                  </Draggable>
                ))}

                {droppableProvided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <ImageModal src={this.state.srcImg} show={this.state.showImg} onHide={this.hideImgModal} />

        <input
          id="imgInput"
          className="m-t-10"
          type="file"
          name="imagen"
          onChange={this.addImg}
          accept="image/png, image/jpeg"
          disabled={this.state.sizeImages > 5}
        />

        <div>
          <button
            hidden={!this.props.publicacion.idPublicacion}
            onClick={this.onSubmit}
            type="submit"
            className="btn pt-2 m-r-10 btn-sm background-rojo-megatone waves-light mb-md-5"
            disabled={this.state.changeImages}
          >
            Guardar Imagenes
          </button>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  seller: state.sellers.seller,
  publicacion: state.publicaciones.publicacion,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(DrawAndDropImages);